































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';

@Component({
  components: {EditDialog, SelectDialogField},
})
export default class RenameDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
}
